import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import { MonthlyTask } from '@app/components/Calendars/components/MonthGrid/components/MonthlyTask';
import { TaskPopover } from '@app/components/Calendars/components/MonthGrid/components/TaskPopover/TaskPopover';
import { useTaskList } from '@app/components/Calendars/components/MonthGrid/hooks/useTaskList';
import type { NCalendars } from '@app/components/Calendars/types';

import '@app/components/Calendars/components/MonthGrid/styles/TaskList.desktop.scss';

export const TaskList: NCalendars.TaskList = ({
  year,
  month,
  day,
  weekDayNumber,
  isBottomWeek,
}) => {
  const {
    containerRef,
    dimensions,
    mainTaskList,
    extraTaskList,
    hasExtraTasks,
    openPreviewTaskModal,
    onMouseEnter,
  } = useTaskList({ year, month, day });

  return (
    <div
      ref={containerRef}
      className={`${CV_PREFIX}-task-list`}
      onMouseEnter={() => {
        onMouseEnter(`${year}-${month}-${day}`);
      }}
    >
      {mainTaskList.map((task) => (
        <MonthlyTask
          key={task.id}
          {...task}
          year={year}
          month={month}
          day={day}
          weekDayNumber={weekDayNumber}
          dimensions={dimensions}
        />
      ))}
      {hasExtraTasks && (
        <TaskPopover
          extraTaskList={extraTaskList}
          width={dimensions.width}
          onClick={openPreviewTaskModal}
          position={isBottomWeek ? 'top' : 'bottom'}
        />
      )}
    </div>
  );
};
